<script>
import AppCard from '@/components/app-card.vue'
import { ref, watch } from '@vue/composition-api'

export default {
  name: 'SettingsSection',
  components: { AppCard },
  props: [
    'label',
    'value',
    'hideSwitch',
    'hintTitle',
    'hintBody',
    'fullWidth',
    'boldText',
    'exampleText',
    'exampleList',
    'type',
  ],
  emits: ['input'],
  setup(props, { emit }) {
    const hintVisible = ref(false)
    const isEnabled = ref(props.value)

    function hideDialog() {
      hintVisible.value = false
    }

    watch(isEnabled, (value) => {
      emit('input', value)
    })

    return {
      isEnabled,
      hintVisible,
      hideDialog,
    }
  },
}
</script>

<template>
  <app-card>
    <div class="header">
      <div class="switch">
        <v-switch v-if="!hideSwitch" v-model="isEnabled" :hide-details="true" />
        <h3>{{ label }}</h3>
      </div>
      <v-btn icon @click="hintVisible = true">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </div>
    <div :class="{ content: !fullWidth }">
      <slot />
    </div>
    <v-dialog v-model="hintVisible" max-width="80%">
      <v-card>
        <div class="headerStylingMb-0">
          <v-card-title>
            {{ hintTitle }}
          </v-card-title>
          <v-btn text icon class="flexCenter mr-2" @click="hideDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <slot name="content" />
      </v-card>
    </v-dialog>
  </app-card>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
}

.switch {
  display: flex;
  gap: 1rem;
  align-items: center;

  div {
    margin: 0;
    padding: 0;
  }
}

.content {
  width: 100%;
  max-width: 30.5rem;
}

.dialogBody {
  padding: 0 1rem 1rem 1rem;
  margin: 0;
}

.headerStylingMb-0 {
  background-color: #d9e4e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
